import IconBook from '@apollo/icons/default/IconBook.svg';
import { Button } from '@apollo/orbit';
import { Moon } from '@apollo/space-kit/illustrations/Moon';
import React from 'react';

import { DocsRouter } from 'src/lib/routers';

export const SetupOperationMetrics = () => {
  return (
    <div className="text-center sm:mx-auto">
      <Moon className="w-[180px]" />
      <>
        <h2 className="my-6 text-3xl font-semibold">Start Tracking</h2>
        <p className="text-secondary">
          It looks like your graph hasn’t received any requests yet.
        </p>
        <p className="text-secondary">
          Learn more on how to set up metrics for your graph using the Apollo
          Router and Server.
        </p>
        <div className="mb-8 mt-6 flex flex-col items-center justify-center md:flex-row">
          <Button
            leftIcon={<IconBook />}
            as="a"
            href={DocsRouter.path('OperationMetrics')}
            target="blank"
            rel="noopener noreferrer"
          >
            Go to the docs
          </Button>
        </div>
      </>
    </div>
  );
};
